import styled from "styled-components";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import TabBar from "../../../../../components/TabBar";
import MainUserSettings from "./MainUserSettings";
import UserRulesSettings from "./UserRulesSettings"

const StyledUserAndRulesRightPane = styled.div`
	margin-left: 30px;
	width: 600px;
`;

function UserAndRulesRightPane(props) {

	const {users, selectedUser, isAddUserMode, setIsAddUserMode, refreshUsersCallback, ...restProps} = props;

    let defaultPath = '/settings/usersettings/';

    let defaultTabPath = 'main';
    let {subTabPath} = useParams();

    let tabs = [
        {text: 'Main settings', path: 'main'},
        {text: 'User rules', path: 'rules'},
    ];

	useEffect(() => {

	});

    return (
        <StyledUserAndRulesRightPane>
			<TabBar tabs={selectedUser.IsCentralOffice ? [tabs[0]] : tabs} defaultPath={defaultPath} selectedSubTabPath={subTabPath ? subTabPath : defaultTabPath} disabled={isAddUserMode}></TabBar>
            {(!subTabPath || subTabPath === '' || subTabPath === 'main') && 
                <MainUserSettings users={users} selectedUser={selectedUser} isAddUserMode={isAddUserMode} setIsAddUserMode={(mode) => {setIsAddUserMode(mode)}} refreshUsersCallback={refreshUsersCallback}></MainUserSettings>
            }
            {subTabPath === 'rules' &&
                <UserRulesSettings selectedUser={selectedUser} refreshUsersCallback={refreshUsersCallback} isAddUserMode={isAddUserMode} setIsAddUserMode={(mode) => {setIsAddUserMode(mode)}} {...restProps}></UserRulesSettings>
            }
		</StyledUserAndRulesRightPane>
    )
}

export default UserAndRulesRightPane;